import React from 'react'
import logoColorido from 'assets/images/logo-empresa.png'
import { colors } from 'theme'
import * as medias from 'consts/medias'
import { useProfile } from 'hooks'
import { padZero } from 'services/utils'
import formatter from 'services/formatter'
import BarCode from 'react-barcode'
import { Box, Typography, useMediaQuery } from '@material-ui/core'
import {
  Print,
  LocalShipping,
  AccountCircle,
  Description,
} from '@material-ui/icons'
import { Dialog, Table } from 'components/index'
import { TableRow, TableCell } from 'components/Table/styles'
import RenderTableRow from 'components/Table/TableRow'
import {
  Container,
  Header,
  Cards,
  GroupContainer,
  StyledButton,
  StyledCard,
  StyledCardIcon,
  StyleCardBody,
} from './styles'
import { unmask } from 'services/masks'

// --------------- ℂ𝕠𝕞𝕡𝕠𝕟𝕖𝕟𝕥𝕤 ---------------

function Card({ Icon, title, content, ...props }) {
  return (
    <StyledCard {...props}>
      <StyledCardIcon>
        <Icon fontSize="large" />
      </StyledCardIcon>
      <StyleCardBody>
        <Typography component="div" variant="body1">
          {title}
        </Typography>
        <Typography component="div" variant="body2">
          {content}
        </Typography>
      </StyleCardBody>
    </StyledCard>
  )
}

// --------------- 𝕄𝕖𝕥𝕒𝕕𝕒𝕥𝕒 ---------------

export const collectStatus = {
  canceled: 1,
  awaitValidation: 2,
  validated: 3,
  validatedBlocked: 4,
  loaded: 5,
  scheduled: 6,
}

export const collectStatusColors = {
  canceled: colors.notification,
  validated: '#4caf50',
  awaitValidation: '#EEAD2D',
  validatedBlocked: '#FF7F00',
  loaded: '#3f51b5',
  scheduled: '#00bcd4',
}

// --------------- 𝕌𝕥𝕚𝕝𝕤 ---------------

export const getColorById = (id) => {
  const statusKey = Object.keys(collectStatus).find(
    (key) => collectStatus[key] === id
  )

  return statusKey
    ? collectStatusColors[statusKey]
    : collectStatusColors.validated
}

export function CollectPrint({ collect, ...props }) {
  const sm = useMediaQuery(medias.sm)
  const carrier = useProfile().company
  const encryptedId = padZero(10, collect.id)

  const scheduleText = () => {
    const label = 'Agendamentos incluidos:'

    const scheduleTexts = collect.schedules
      .filter((s) => s.ford_senha)
      .map((s) => `${s.ford_senha} (${formatter(s.ford_data).toSimpleDate()})`)
      .join(', ')

    return scheduleTexts.length > 0 ? (
      <Box marginY={2}>
        <Typography color="primary" component="span" variant="subtitle2">
          <Box component="b" marginRight={1}>
            {label}
          </Box>
          <span>{scheduleTexts}</span>
        </Typography>
      </Box>
    ) : null
  }

  const columns = [
    { title: 'PEDIDO', field: 'cod_pedido' },
    { title: 'SEU PEDIDO', field: 'ped_seupedido' },
    { title: 'PRODUTO', field: 'dsc_produto' },
    {
      title: 'QUANTIDADE',
      field: 'vpt_qtd',
      cellFormat: 'decimal',
      align: 'right',
    },
    {
      title: 'PESO',
      field: 'vpt_peso_bruto',
      cellFormat: 'decimal',
      align: 'right',
    },
    {
      title: 'ENTREGA',
      field: 'vpt_data_prev_entrega',
      cellFormat: 'date',
    },
    { title: 'FRETE', field: 'ped_tipo_frete' },
    { title: 'REPRESENTANTE', field: 'ped_representante' },
  ]

  function handleInviteAndPrint() {
    window.print()
  }

  const cellStyle = ({ columnName }) =>
    columnName === 'dsc_produto' ? { whiteSpace: 'nowrap' } : {}

  return (
    <Dialog
      {...props}
      fullWidth
      fullScreen={sm}
      maxWidth="md"
      title={`Impressão Coleta ${collect.id}`}
      className="printable"
      actions={
        <>
          <StyledButton
            startIcon={<Print />}
            className="info light"
            label="Imprimir"
            variant="contained"
            onClick={handleInviteAndPrint}
          />
          <StyledButton
            className="error light"
            label="Fechar"
            variant="contained"
            onClick={props.onClose}
          />
        </>
      }
    >
      <Container>
        <Header>
          <div className="Header-barcode">
            <BarCode
              height={sm ? 30 : 100}
              value={encryptedId}
              displayValue={false}
            />
          </div>
          <div className="Header-content">
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>
              Savane - Pedido de Coleta
            </Typography>
            <Typography gutterBottom component="div" variant="body1">
              {collect.status.descr}
            </Typography>
            <Typography component="div" variant="body1">
              <b>Transportadora:</b>
              <span>{carrier.emp_razao_social}</span>
            </Typography>
            <Typography gutterBottom component="div" variant="body1">
              <b>Nº Coleta:</b>
              <span>{collect.id}</span>
            </Typography>
            <Box display="flex">
              <Typography component="div" variant="body1">
                <b>Emissão:</b>
                <span>{collect.date}</span>
              </Typography>
              {collect.lastUpdateDate && (
                <Typography
                  component="div"
                  variant="body1"
                  style={{ marginLeft: '12px' }}
                >
                  <b>Ultima Alteração:</b>
                  <span>{collect.lastUpdateDate}</span>
                </Typography>
              )}
            </Box>
            <Typography component="div" variant="body1">
              <b>Impressão:</b>
              <span>{collect.printDate}</span>
            </Typography>
          </div>
          <div className="Header-logo">
            <img src={logoColorido} alt="logo" />
          </div>
        </Header>
        <Cards>
          <Card
            Icon={AccountCircle}
            title={collect.driver.name}
            content={
              <p>{formatter(unmask(collect.driver.id)).toCNPJorCPF()}</p>
            }
          />
          <Card
            Icon={LocalShipping}
            title={collect.truck.plate}
            content={<p>{collect.truck.dsc_caminhao}</p>}
          />
          <Card
            Icon={Description}
            title={`Prev. Entrega: ${collect.prevDate}`}
            content={<p>{collect.obs}</p>}
          />
        </Cards>
        <Table
          groupBy="cod_cliente"
          size="medium"
          data={collect.items}
          columns={columns}
          stripped={false}
          cellStyle={cellStyle}
          components={{
            Group: ({ rowData }) => {
              const customer = rowData.customer
              const customerStr = `${customer.emp_razao_social} (${formatter(
                rowData.cod_cliente
              ).toCNPJorCPF()})`
              return (
                <TableRow>
                  <TableCell
                    colSpan={columns.length}
                    style={{
                      borderBottom: `1px solid ${colors.color300}`,
                    }}
                  >
                    <GroupContainer>
                      <b>{customerStr}</b>
                      <span>{customer.emp_endereco}</span>
                    </GroupContainer>
                  </TableCell>
                </TableRow>
              )
            },
            Footer: (props) => {
              return (
                <RenderTableRow
                  {...props}
                  rowData={{
                    cod_pedido: 'TOTAL',
                    vpt_qtd: collect.totalQuantity,
                    vpt_peso_bruto: collect.totalWeight,
                  }}
                />
              )
            },
          }}
        />

        {scheduleText()}
      </Container>
    </Dialog>
  )
}

export default CollectPrint
